import PropTypes from "prop-types"
import React from "react"
import TextAnalysisCloudGHGEmission from "views/molecules/canvases/charts/cloud/TextAnalysisCloudGHGEmission"
import TextAnalysisCloudEmissionsPerCost from "views/molecules/canvases/charts/cloud/TextAnalysisCloudEmissionsPerCost"
import TextAnalysisCloudServiceInCarbonCountry from "views/molecules/canvases/charts/cloud/TextAnalysisCloudServiceInCarbonCountry"
import TextChartODD13EmissionsPerKeyMetricMolecule from "views/molecules/canvases/charts/TextChartODD13EmissionsPerKeyMetricMolecule"
import ScoreLayoutOrganism from "views/organisms/scores/ScoreLayoutOrganism"
import ChartCloudServiceCostsDispatcher from "views/organisms/canvases/charts/ITDomainAnalysis/dispatcher/ChartCloudServiceCostsDispatcher"
import ChartCloudRegionsDispatcher from "views/organisms/canvases/charts/ITDomainAnalysis/dispatcher/ChartCloudRegionsDispatcher"
import ChartCloudLowUseDispatcher from "views/organisms/canvases/charts/ITDomainAnalysis/dispatcher/ChartCloudLowUseDispatcher"
import { useAppContext } from "components/AppContext"

const CloudAnalysisOrganism = ({ score, isOnGlobalDashboard }) => {
  const { currentNode, score: globalScore } = useAppContext()
  const { cloud_score } = score

  const chart1TrendBadge = globalScore?.trend_badges?.odd13_datacenter_CO2_cloud
  const chart2TrendBadge = globalScore?.trend_badges?.cloud_emissions_per_cost
  const chart5TrendBadge =
    globalScore?.trend_badges?.cloud_high_ghg_intensity_percentage
  const chart5KeyMetricTrendBadge =
    globalScore?.trend_badges?.odd13_emissions_per_key_metric
  const maturityTrendBadge =
    globalScore?.trend_badges?.odd13_datacenter_external_cloud_maturity

  const emissions_per_cost = cloud_score?.emissions_per_cost

  const keyMetricFigure = Number(currentNode?.characteristic?.key_metric_figure)
  const keyMetricUnit = currentNode?.characteristic?.key_metric_unit
  const hasKeyMetric =
    Number.isFinite(keyMetricFigure) && keyMetricFigure > 0 && !!keyMetricUnit

  const chart5 =
    isOnGlobalDashboard && hasKeyMetric ? (
      <TextChartODD13EmissionsPerKeyMetricMolecule
        emissions={Number(score?.odd13_CO2 || 0)}
        keyMetricFigure={keyMetricFigure}
        keyMetricUnit={keyMetricUnit}
        trendBadge={chart5KeyMetricTrendBadge}
      />
    ) : (
      <TextAnalysisCloudServiceInCarbonCountry
        value={score?.cloud_score?.high_ghg_intensity_percentage}
        trendBadge={chart5TrendBadge}
      />
    )

  return (
    <ScoreLayoutOrganism
      maturity={score?.odd13_datacenter_external_cloud_maturity}
      maturityTrendBadge={maturityTrendBadge}
      chart1={
        <TextAnalysisCloudGHGEmission
          score={score}
          hidePercentageOfEmissions={isOnGlobalDashboard}
          trendBadge={chart1TrendBadge}
        />
      }
      chart2={
        <TextAnalysisCloudEmissionsPerCost
          emissionsPerCost={emissions_per_cost}
          trendBadge={chart2TrendBadge}
        />
      }
      chart3={<ChartCloudRegionsDispatcher envScore={score} />}
      chart4={<ChartCloudServiceCostsDispatcher envScore={score} />}
      chart5={chart5}
      chart6={<ChartCloudLowUseDispatcher envScore={score} />}
    />
  )
}

CloudAnalysisOrganism.propTypes = {
  score: PropTypes.object.isRequired,
  isOnGlobalDashboard: PropTypes.bool,
  trendBadges: PropTypes.object,
}

CloudAnalysisOrganism.defaultProps = {
  isOnGlobalDashboard: false,
  trendBadges: {},
}

export default CloudAnalysisOrganism
